import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import GUIset_Single from "./gui/GUIset_Single";
import Template from "./TheTemplate";

const LIS = () => {
	useEffect(() => {
		document.title = "Longest Increasing Subsequence";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState("50,3,10,7,40,80,14,19,99");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "") {
			arr = T.str_toListInt(guiTxt1);
			//----------------------
			Timer.setTimeBudget(4999);
			Timer.start();
			process();
			txt_time = Timer.stop_print();
			//--------------------------
			BuildResult();
			arr = [];
			optimal_list = [];
			result_lis = null;
		}
	};

	var txt_time = "";
	var arr = [];

	var map; // int[][] map;//storage
	// var map_list; // keepset
	// var optimal_list = [[]]; //can have more than 1 : but keep only one
	var optimal_list = []; //only 1 is kept because we use memory to skip processing, not try all combination
	var optimal_v = -9999;
	var result_lis; // = optimal_v

	function process() {
		var max_v = T.arr_max(arr) + 1;
		map = T.getMatrix(arr.length, max_v, -9999);
		// map_list = T.getMatrix(arr.length, max_v, []);
		optimal_list = [[]];
		optimal_v = -9999;
		result_lis = LIS([], arr.length, max_v, 0);
		console.log("result " + result_lis);
		// console.log("XXX " + optimal_list[0]);
	}

	//n is last index, search 0 to n
	//v is the next value, find value < v
	// int longest(int n, int v, int count) {
	function LIS(list, n, v, count) {
		if (Timer.timeout()) {
			return;
		} //Check time out first
		//-------------------------------
		if (n == 0) {
			if (arr[n] < v) {
				return count + 1;
			} else {
				return count;
			}
		}
		if (map[n - 1][v - 1] > -1) {
			// console.log("C " + list + " ___ " + map_list[n - 1][v - 1]);
			// list.push(...map_list[n - 1][v - 1]);
			return map[n - 1][v - 1];
		}
		var longest = 0;
		for (var i = n - 1; i >= 0; i--) {
			var x1 = longest;
			var x2 = longest;
			if (arr[i] < v) {
				var list_new = T.listAdd(list, arr[i]);
				x1 = LIS(list_new, n - 1, arr[i], count + 1);
			} //add (if pass a rule)
			x2 = LIS(list, n - 1, v, count); //not add (optional)
			//---------
			longest = Math.max(x1, longest);
			longest = Math.max(x2, longest);
			if (x1 > longest && x1 > x2) {
				list = list_new;
			}
		}
		map[n - 1][v - 1] = longest;
		// map_list[n - 1][v - 1] = list;
		if (longest > optimal_v) {
			// optimal_list = [list];
			optimal_list = list;
			optimal_v = longest;
		} 
		// else if (list.length > optimal_v ) {
		// 	optimal_list.push(list);
		// } 
		return longest;
	}

	function BuildResult() {
		var txt = "";
		var txt2 = "";
		txt += txt_time;
		txt += Timer.reachLimit() ? " (limited)\n" : "\n";
		txt += "Length of LIS: " + result_lis;
		// for (var a = 0; a < optimal_list.length; a++) {
		// 	if (txt2 != "") {
		// 		txt2 += "\n";
		// 	}
		// 	txt2 += "[" + optimal_list[a].reverse() + "]";
		// }
		txt2 += "["+ optimal_list.reverse() + "]";
		if(optimal_list.length > 0) {txt2 += " is the LIS, or one of them."; }
		partResultChange(Template.simple01x2("set1","Result",txt,22,"LIS",txt2,20));
	}

	return (
		<GUIset_Single
			title={"Longest Increasing Subsequence (LIS)"}
			desc={
				"Find the length of the longest subsequence of a given sequence such that all elements of the subsequence are sorted in increasing order."
			}
			guiTxt={guiTxt1}
			guiTxtChange={guiTxtChange1}
			buttonClick={buttonClick1}
			partResult={partResult}
			label1={"Array"}
			txtButton={"Analyze"}
			// isNumOnly = {true}
		/>
	);

};

export default LIS;




// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";

	// //n is last index, search 0 to n
	// //v is the next value, find value < v
	// // int longest(int n, int v, int count) {
	// function LIS(n, v, count) {
	// 	if (n == 0) {
	// 		if (arr[n] < v) {
	// 			return count + 1;
	// 		} else {
	// 			return count;
	// 		}
	// 	}
	// 	if (map[n - 1][v - 1] > -1) {
	// 		return map[n - 1][v - 1];
	// 	}
	// 	var longest = 0;
	// 	for (var i = n - 1; i >= 0; i--) {
	// 		var x1 = longest;
	// 		var x2 = longest;
	// 		if (arr[i] < v) {
	// 			x1 = LIS(n - 1, arr[i], count + 1);
	// 		} //add (if pass a rule)
	// 		x2 = LIS(n - 1, v, count); //not add (optional)
	// 		longest = Math.max(x1, longest);
	// 		longest = Math.max(x2, longest);
	// 	}
	// 	map[n - 1][v - 1] = longest;
	// 	result_v = v;
	// 	result_n = n;
	// 	return longest;
	// }

	



	// function BuildResult() {
	// 	var txt = "";
	// 	var txt2 = "";
	// 	var part1 = [<div></div>];
	// 	var part2 = [<div></div>];
	// 	//------------------------
	// 	txt += txt_time;
	// 	txt += Timer.reachLimit() ? " (limited)\n" : "\n";
	// 	//-----
	// 	txt += "Length of LIS: " + result_lis;
	// 	//---------
	// 	for (var a = 0; a < optimal_list.length; a++) {
	// 		if (txt2 != "") {
	// 			txt2 += "\n";
	// 		}
	// 		txt2 += "[" + optimal_list[a].reverse() + "]";
	// 	}
	// 	//---------
	// 	part1 = [
	// 		<div key="part1">
	// 			<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
	// 				<h2>Result</h2>
	// 			</div>
	// 			<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt}</div>
	// 		</div>,
	// 	];
	// 	part2 = [
	// 		<div key="part2">
	// 			<br />
	// 			<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>
	// 				<b>LIS</b>
	// 			</div>
	// 			<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>{txt2}</div>
	// 		</div>,
	// 	];

	// 	partResultChange(
	// 		<div>
	// 			<div>{part1} </div>
	// 			<div>{part2} </div>
	// 		</div>
	// 	);


	// 	partResultChange(Template.simple01x2("Result",txt,22,"Number",txt1,20));
	// }
	//--------------------------------------------------------

	// return (
	// 	<div className="todoapp stack-large">
	// 		<GUI_Header
	// 			title={"Longest Increasing Subsequence (LIS)"}
	// 			desc={
	// 				"Find the length of the longest subsequence of a given sequence such that all elements of the subsequence are sorted in increasing order."
	// 			}
	// 		/>
	// 		<div style={{ marginTop: "3em" }}> </div>
	// 		<GUI_InputTextSingle
	// 			label={"Array"}
	// 			text1={guiTxt1}
	// 			text1Change={guiTxtChange1}
	// 			numberOnly={false}
	// 			width1={100}
	// 			fontSize2={24}
	// 			width2={'90%'}
	// 		/>
	// 		<div style={{ display: "flex", marginLeft: '15%',marginRight: 0 }}>
	// 			<button
	// 				onClick={() => buttonClick1()}
	// 				className="btn btn__primary btn__lg"
	// 				style={{ flex: 1, height: 50 }}
	// 			>
	// 				Calculate
	// 			</button>
	// 		</div>
	// 		<div style={{ marginTop: "3em" }}> </div>
	// 		{partResult}
	// 		<GUI_Credit />
	// 	</div>
	// );